if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function(e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function(e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      image_container.addEventListener('touchstart', mousemove, {
        passive: true
      });
      image_container.addEventListener('touchmove', mousemove, {
        passive: true
      });
      image_container.addEventListener('touchend', mouseleave, {
        passive: true
      });
      image_container.addEventListener('mouseenter', mousemove, {
        passive: true
      });
      image_container.addEventListener('mousemove', mousemove, {
        passive: true
      });
      image_container.addEventListener('mouseleave', mouseleave, {
        passive: true
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active');

      swatch_list.forEach((swatch, index) => {

        swatch.addEventListener('mouseover', function() {

          [].forEach.call(swatch_list, function(el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function(evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}
if(!customElements.get('add-to-cart')) {
  class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.quick_add = this;
    }
    connectedCallback() {
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.hasAttribute('disabled')) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      if(this.dataset.addons) {
        console.log(this.dataset.addons.split(','));
        let addons = this.dataset.addons.split(',')
        if(addons.length) {
          addons.forEach(cb => {
            if(cb) {
              formData.append('items[][id]', cb);
              formData.append('items[][quantity]', 1);
              formData.append('items[][properties][_MainProductVariantId]', formData.get('id')); // 设置关联属性              
            }
          });
        }
      }

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('add-to-cart', BuyNow);
}
/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');
              document.querySelector('#Product-Drawer-Content').innerHTML = '';
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    // cc.addEventListener('click', (e) => {
    //   let panel = document.querySelector('.side-panel.active');
    //   if (panel) {
    //     panel.classList.remove('active');
    //     document.body.classList.remove('open-cc');
    //   }
    // });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      document.querySelector('#Product-Drawer-Content').innerHTML = '';
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input'),
      checkout_button = this.container.querySelector('.button.checkout');

    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.newCheckoutEvent()
    // Terms checkbox
    this.termsCheckbox();
    // 清空recModal产品
    this.checkCarthasRecProd()
    
    window.addEventListener('pageshow', function(event) {
      // 检测是否从缓存中恢复
      if (event.persisted) {
        // 页面从 BFCache 恢复，强制刷新
        console.log("页面从 BFCache 恢复页面从 BFCache 恢复页面从 BFCache 恢复");
        window.location.reload();
        
      }
    });
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      if(event.target.value == 0) {
        let lineItems = document.querySelectorAll('.product-cart-item')
        let lineAddOnData = {
          [lineItems[event.target.dataset.index - 1].dataset.lineKey]: 0
        }, haveAddOn = false
        lineItems.forEach((item, index) => {
          if(item.dataset.mainProduct&&(item.dataset.mainProduct === lineItems[event.target.dataset.index - 1].dataset.variantId)) {
            haveAddOn = true
            lineAddOnData[item.dataset.lineKey] = 0
          }
        })
        if(haveAddOn) {
          this.bulkUpdate(lineAddOnData)
        }else {
          this.updateQuantity(event.target.dataset.index, event.target.value, event.target.dataset.id);
        }
      }else {
        this.updateQuantity(event.target.dataset.index, event.target.value, event.target.dataset.id);
      }
      
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        let lineItems = document.querySelectorAll('.product-cart-item')
        let lineAddOnData = {
          [lineItems[event.target.dataset.index - 1].dataset.lineKey]: 0
        }, haveAddOn = false
        lineItems.forEach((item, index) => {
          if(item.dataset.mainProduct&&(item.dataset.mainProduct === lineItems[event.target.dataset.index - 1].dataset.variantId)) {
            haveAddOn = true
            lineAddOnData[item.dataset.lineKey] = 0
          }
        })
        if(haveAddOn) {
          this.bulkUpdate(lineAddOnData)
        }else {
          this.updateQuantity(event.target.dataset.index, '0');          
        }


        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    },{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function(e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateQuantity(line, quantity, mainId) {
    
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            if(elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);              
            }

          }
        }));
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        this.removeProductEvent();
        this.newCheckoutEvent()
        this.notesToggle();
        this.termsCheckbox();
        this.checkCarthasRecProd()
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
        
        if(quantity == '0') {
          let addOns = {},haveAddOn = false
          parsedState.items.forEach(citem => {
            if(citem.properties._MainProductVariantId) {
              haveAddOn = true
              if(!parsedState.items.find(_item => _item.variant_id == citem.properties._MainProductVariantId)) {
                addOns[citem.variant_id] = 0
              } 
            }
          })
          if(haveAddOn)this.bulkUpdate(addOns)
        }else {
          if(!mainId) return
          let freeProducts = parsedState.items.filter(_item => _item.properties._freeProduct && _item.properties._freeProduct == mainId)
          if(freeProducts.length) {
            const currentFreeTotal = freeProducts.reduce((sum, item) => sum + item.quantity, 0);
            const diff = quantity - currentFreeTotal
            let updates = {}
            if(diff > 0) {
              const firstFreeProd = freeProducts[0]
              const addQuantity = firstFreeProd.quantity + diff
              updates[firstFreeProd.variant_id] = addQuantity
              this.bulkUpdate(updates)
            } else if(diff < 0) {
              // 情况2：主产品数量减少 → 从最新的免费产品开始减少或删除
              let remainingReduction = Math.abs(diff); // 需减少的总量
              let index = 0;
              // 从第一个免费产品开始遍历，直到减少量分配完毕
              while (remainingReduction > 0 && index < freeProducts.length) {
                const currentFreeProduct = freeProducts[index];
                
                if (currentFreeProduct.quantity > remainingReduction) {
                  // 当前免费产品数量足够：减少部分数量即可
                  const newQuantity = currentFreeProduct.quantity - remainingReduction;
                  this.bulkUpdate({[currentFreeProduct.id]: newQuantity})
                  remainingReduction = 0; // 减少量已全部处理
                } else {
                  // 当前免费产品数量不足：删除该产品，并继续减少下一个
                  remainingReduction -= currentFreeProduct.quantity; // 扣除该产品全部数量
                  this.bulkUpdate({[currentFreeProduct.id]: 0})
                  index++; // 移至下一个免费产品（新的"最新"产品）
                }
              }

              // 如果遍历完所有免费产品后仍需减少（理论上不应发生，因总和逻辑）
              if (remainingReduction > 0) {
                console.warn(`警告：免费产品总数量不足，仍需减少 ${remainingReduction} 但无更多免费产品可操作`);
              }
            }
          }
        }
      });
  }
  bulkUpdate(updates) {
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log(parsedState);
        

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            if(elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);              
            }

          }
        }));
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        this.removeProductEvent();
        this.newCheckoutEvent()
        this.notesToggle();
        this.termsCheckbox();
      });
  }
  newCheckoutEvent() {
    let rec_checkout_button = this.container.querySelector('.new-cart-drawer-checkout')
    console.log(rec_checkout_button);
    let other_checkBtns = document.querySelectorAll('.new-cart-drawer-checkout')
    other_checkBtns.forEach(otherBtn => {
      if(otherBtn && otherBtn != rec_checkout_button) {
        otherBtn.addEventListener('click', window.openRecModal)
      }
    })
    if(rec_checkout_button) {
      if(window.openRecModal) {
        rec_checkout_button.addEventListener('click', window.openRecModal)
      }
    }
  }
  async checkCarthasRecProd() {
    console.log('clear update.js from checkCarthasRecProd app.js');
    
    const res = await fetch('/cart.js',{
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      cache: 'no-store'  // 强制不使用缓存
    }).then(res => res.json()).then(data=>{
      let addOns = {},haveAddOn = false
      console.log('clear update.js data', data);
      
      data.items.forEach(citem => {
        if(citem.properties._recModal) {
          haveAddOn = true
            addOns[citem.variant_id] = 0
        }
      })
      if(haveAddOn)this.bulkUpdate(addOns)
    })
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function() {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function() {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function() {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function() {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
          method: 'GET'
        })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider'),
            flkty = Flickity.data(slider);

          flkty.reposition();
        }, 100);
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}
document.addEventListener('DOMContentLoaded', () => {
// 推荐弹窗
let globalCartItems = []
function uniqueById(arr) {
  return [...new Map(arr.map(item => [item.id, item])).values()];
}
async function getCartWithMetafields() {
  let cartData = null
    const res = await fetch('/?section_id=cart-with-metafields').then(res => res.text())
            .then(text => {
              // 去掉外层 div，只提取中间的 JSON 部分
              const clean = text.replace(/^<div[^>]*>/, '').replace(/<\/div>$/, '').trim();
              const data = JSON.parse(clean);
              console.log(data);
              globalCartItems = data.items
              cartData = uniqueById(data.cartMetaProduct) || []
              
            })
            .catch(err => {
              console.log('get cart error',err)
              return []
            }); // 需要创建对应的模板
  
  return cartData ? cartData : [];
}
async function createModal(modalData) {
  let newCheckoutBtn = document.querySelector('.new-cart-drawer-checkout')
  if(newCheckoutBtn) newCheckoutBtn.classList.add('loading')
  let cartWithMetafields = []
  if(modalData) {
    cartWithMetafields = modalData.cartMetaProduct || []
  }else {
    cartWithMetafields = await getCartWithMetafields()
  }
  
  if(newCheckoutBtn) newCheckoutBtn.classList.remove('loading')
  if( !cartWithMetafields.length ) {
    window.location.href = '/checkout'
    return { cartWithMetafields }
  }

    // 创建遮罩层
    const overlay = document.createElement('div');
    overlay.className = 'rec-modal-overlay';
    overlay.id = 'rec-modalOverlay';
    
    // 创建弹窗内容 - 使用模板字符串构建复杂结构
    const content = document.createElement('div');
    content.className = 'rec-modal-content';
    content.id = 'rec-modalContent';
    
    // 使用模板字符串构建产品列表HTML
    const productsHTML = cartWithMetafields.map(product => {
        variantsHTML = product.variants.length > 1 ? product.variants.map((v, i) =>
        `<button class="rec-v-option ${i===0&&'active'}" data-variant-id="${v.id}">${v.title}</button>`
        ).join('') : ''
        return `
            <div class="rec-prod-option">
                <label class="rec-prod-label" data-variant-id="${product.first_available_variant_id}">
                    <div class="rec-checkbox-con">
                        <input type="checkbox" class="rec-checkbox" data-variant-id="${product.first_available_variant_id}">
                        <span class="rec-custom-checkbox">
                            <svg viewBox="0 0 16 16" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><path class="Polaris-Checkbox--checked" d="M1.5,5.5L3.44655,8.22517C3.72862,8.62007,4.30578,8.64717,4.62362,8.28044L10.5,1.5" transform="translate(2 2.980376)" opacity="0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" pathLength="1"></path></svg>
                        </span>
                    </div>
                    <div style="width: 100%;display:flex;flex-direction:column">
                        <div class="rec-variant">
                            <img src="${product.img}">
                            <div class="rec-info">
                                <div class="rec-prod-title">${ product.alias || product.title}</div>
                                <div class="rec-prod-price">
                                    <span>${product.price}</span>
                                    <span>${product.compare_at_price ? product.compare_at_price : ''}</span>
                                    <span class="rec-save-badge">Save ${product.saved_amount}%</span>
                                </div>
                                <div class="rec-v-variants">${variantsHTML}</div>
                            </div>                            
                        </div>

                    </div>

                </label>
            </div>
        `;
    }).join('');
    
    // 构建完整的弹窗内容
    content.innerHTML = `
        <div class="rec-modal-top-head">
            <div class="rec-modal-header">
                <div class="rec-modal-head-title">
                    Don't forget the special offers
                </div>
                <div class="rec--close-btn" id="rec-closeModal">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </div>
            </div>
        </div>
        <div class="rec-product-list">
            <div class="rec-list-content">${productsHTML}</div>
        </div>
        <div class="rec-modal-footer">
            <div class="rec-modal-cta">
                <div>
                    <div class="rec-modal-footer-btn rec-skip-btn" style="font-size: 15px;border-radius: 10px">Skip this offer </div>
                </div>
                <div class="rec-atc-btn rec-btn-disabled">
                  <div class="rec-modal-footer-btn rec-submit-btn button" style="color: rgb(255, 255, 255); font-size: 15px; font-weight: 700; border-width: 0px; border-radius: 10px; background-color: rgb(8, 10, 12);margin-top: 12px; padding: 12px 20px; border-style: solid;">
                    <span>Add items to cart</span>
                    <div class="loading-overlay">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
                      </svg>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    `;
    
    // 添加到body
    document.body.appendChild(overlay);
    document.body.appendChild(content);
    
    // 获取关闭按钮
    const closeBtn = content.querySelector('#rec-closeModal');
    
    return { overlay, content, closeBtn, cartWithMetafields };
}

    // 打开弹窗函数
async function openModal(modalData) {
  if(modalData instanceof Event || (modalData && modalData.type && modalData.target)) {
    modalData = ''
  }
  // 创建新的DOM元素
  const res = await createModal(modalData);
  const { cartWithMetafields } = res
  if(!cartWithMetafields.length) return
  const { overlay, content, closeBtn }  = res
  console.log('cart metafields data', cartWithMetafields);
        
  // 显示弹窗
  overlay.style.display = 'block';
  content.style.display = 'flex';
  
  // 事件监听器
  closeBtn.addEventListener('click', () => closeModal(modalData));
  overlay.addEventListener('click', () => closeModal(modalData));
  skitBtn = content.querySelector('.rec-skip-btn')
  skitBtn.addEventListener('click', () => closeModal(modalData))
        
  // 阻止点击弹窗内容时关闭弹窗（事件冒泡）
  content.addEventListener('click', function(event) {
      if (event.target.id !== 'rec-closeModal') {
          event.stopPropagation();
      }
  });
  // 变体选择
  const recVariantOption = content.querySelectorAll('.rec-v-option')
  const recCheckbox = Array.from(content.querySelectorAll('.rec-checkbox'))
  let recAtcBtn = content.querySelector('.rec-atc-btn')
  recVariantOption.forEach( option => {
      option.addEventListener('click', function(event) {
          event.stopPropagation()
          const parent = option.closest('.rec-prod-label')
          parent.querySelectorAll('.rec-v-option').forEach(o => o.classList.remove('active'))
          option.classList.add('active')
          parent.dataset.variantId = option.dataset.variantId;
          // if(payment_button) payment_button.style.display = 'none'
          parent.querySelector('.rec-checkbox').dataset.variantId = option.dataset.variantId
          if(!parent.querySelector('.rec-checkbox').checked) {
              parent.querySelector('.rec-checkbox').checked = true
              parent.querySelector('.rec-v-variants').classList.add('checked')
              parent.classList.add('checked')
          }
          enableAddBtn()
      })
  })
  recCheckbox.forEach(option => {
      option.addEventListener('change', (e) => {
          const parent = option.closest('.rec-prod-label')
          if(e.target.checked) {
              parent.classList.add('checked')
              parent.querySelector('.rec-v-variants')?.classList.add('checked')
          }else {
              parent.classList.remove('checked')
              parent.querySelector('.rec-v-variants')?.classList.remove('checked')
          }
          enableAddBtn()
      })
  })
  function enableAddBtn() {
      let hasChecked = recCheckbox.some(item => item.checked)
      if(hasChecked) {
          if(recAtcBtn) recAtcBtn.classList.remove('rec-btn-disabled')
      } else {
          if(recAtcBtn) recAtcBtn.classList.add('rec-btn-disabled')
      }
  }

  // 确认加购点击事件
  const recSubmitBtn = content.querySelector('.rec-submit-btn');
  const directCheckoutBtn = document.getElementById('direct-checkout')
  recSubmitBtn.addEventListener('click', async function() {
      // 拼永久链接形式
              // let checkedItems = recCheckbox.filter(checkbox => checkbox.checked).map(el => `${el.dataset.variantId}:1`);
      // const cartItemsData = globalCartItems
      // const cartItems = cartItemsData.map(item => `${item.variant_id}:${item.quantity}`);
      // const allItems = [...cartItems, ...checkedItems]
      // // const discountCode = 'YOUR_DISCOUNT_CODE'; // 可选
      // const checkoutUrl = `/cart/${allItems.join(',')}`;
      // console.log(checkoutUrl);
      
      // // 跳转结账页
      // window.location.href = checkoutUrl;
      // add to cart 形式
    if(modalData){
      let prodItems = modalData.items 
      console.log(prodItems);
      let checkedItems = recCheckbox.filter(checkbox => checkbox.checked).map(el => ({
        id: el.dataset.variantId,
        quantity: 1,
        properties: { _recModal: true }
      }))
      console.log([...prodItems, ...checkedItems]);
      recSubmitBtn.classList.add('loading')
      let allItems = [...prodItems, ...checkedItems]

      try {
        // 1. 先清空购物车
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: allItems })
        })
        recSubmitBtn.classList.remove('loading')
        closeModal(null)
        // 3. 跳转到结账
        window.location.href = '/checkout';
        
      } catch (error) {
        closeModal('product')
        recSubmitBtn.classList.remove('loading')
        console.error('操作失败:', error);
      }
    }else {
      let checkedItems = recCheckbox.filter(checkbox => checkbox.checked).map(el => ({
        id: el.dataset.variantId,
        quantity: 1,
        properties: { _recModal: true }
      }))
      recSubmitBtn.classList.add('loading')
      const res = await fetch('/cart/add.js', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: checkedItems })
      })
      recSubmitBtn.classList.remove('loading')
      closeModal()
      window.location.href = '/checkout'
    }
  })
  
  
  // // ESC键关闭弹窗
  // const escHandler = function(event) {
  //     if (event.key === 'Escape') {
  //         closeModal();
  //     }
  // };
  // document.addEventListener('keydown', escHandler);
  
  // 

  // 保存事件处理器以便移除
  window.currentModal = {
      overlay,
      content,
      // escHandler // esc按键
  };
}

// 关闭弹窗函数
function closeModal(modalData) {
    if (window.currentModal) {
        // 移除DOM元素
        document.body.removeChild(window.currentModal.overlay);
        document.body.removeChild(window.currentModal.content);
        
        // 移除事件监听器
        // document.removeEventListener('keydown', window.currentModal.escHandler);
        
        // 清除引用
        window.currentModal = null;
        
        // 触发关闭事件
        if (window.onRecModalClose) {
            window.onRecModalClose(modalData);
        }
    }
}

// 打开弹窗按钮事件
// document.querySelector('.new-cart-drawer-checkout').addEventListener('click', openModal);

// 预留全局关闭事件回调函数
window.onRecModalClose = async function(modalData) {
    // console.log('产品推荐弹窗已关闭');
    // 自定义关闭后操作
    if(modalData === null) {
      return
    }
    if(!modalData) {
      window.location.href = '/checkout'    
    }
    if(modalData) {
      console.log('product page');
      try {
        // 1. 先清空购物车
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: modalData.items })
        })

        // 3. 跳转到结账
        window.location.href = '/checkout';
        
      } catch (error) {
        // 构建购物车链接
        const cartItems = modalData.items.map(p => `${p.id}:${p.quantity}`).join(',');
        const checkoutUrl = `/cart/${cartItems}`;
        // 跳转到结账
        window.location.href = checkoutUrl;
        console.error('操作失败:', error);
      }
    }

}; 
window.openRecModal = openModal

  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

